import ultrasoundEn from './ultrasound/en.json';
import ultrasoundZhHant from './ultrasound/zh-Hant.json';
import ultrasoundVi from './ultrasound/vi.json';
import ultrasoundTh from './ultrasound/th.json';

export default {
  en: ultrasoundEn,
  'zh-Hant': ultrasoundZhHant,
  vi: ultrasoundVi,
  th: ultrasoundTh,
};
